// Browser-tab title for a route. Used as the route's `head` option; the root
// route renders <HeadContent /> which hoists it into <head>. Page first, app
// last, so a truncated tab still shows the distinct part.
export function pageHead(title: string) {
  return { meta: [{ title: `${title} · Sync your finances` }] };
}
